<section>
  <mat-dialog-content class="mat-typography">
    <div class="d-flex align-items-center">
      <button class="back_icon me-2" (click)="closeDialog(false)">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
      <h2 translate class="align-items-center m-0 justify-content-center">
        Add Banners
      </h2>
    </div>
    <mat-divider></mat-divider>

    <form [formGroup]="bannersForm" class="container p-4">
      <div>
        <!-- Banner Title Input -->
        <app-question
          [question]="questions[0]"
          [form]="bannersForm"
        ></app-question>

        <!-- Upload Box -->
        <div>
          <input
            #fileInput
            hidden
            type="file"
            (change)="imageInputChange($event)"
          />
          <div
            (click)="fileInput.click()"
            class="d-flex align-items-center Image_contaner_size justify-content-center"
          >
            <ng-container *ngIf="!selectedImageUrl">
              <img
                src="../../../../../../assets/images/bulkupload_logo.svg"
                alt="Upload Banner"
                class="img-fluid"
              />
              <p translate class="image-dimensions-note">
                *Recommended: 1920px (W) × 720px (H)
              </p>
            </ng-container>

            <!-- Display Selected Image -->
            <ng-container *ngIf="selectedImageUrl">
              <img
                [src]="selectedImageUrl"
                alt="Selected Image"
                class="img-fluid"
              />
            </ng-container>
          </div>
        </div>

        <!-- Additional Inputs -->
        <div class="additional-fields">
          <app-question
            [question]="questions[1]"
            [form]="bannersForm"
          ></app-question>
          <app-question
            [question]="questions[2]"
            [form]="bannersForm"
          ></app-question>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <!-- Buttons Section -->
  <mat-dialog-actions
    align="end"
    class="w-100 bg-white position-absolute bottom-0 end-0"
  >
    <button
      translate
      mat-stroked-button
      (click)="closeDialog(false)"
      class="cancel-btn cancel_button"
    >
      Cancel
    </button>
    <button
      translate
      mat-raised-button
      color="primary"
      class="submit-btn"
      type="submit"
      [disabled]="!bannersForm.valid"
      (click)="onSubmit()"
    >
      Submit
    </button>
  </mat-dialog-actions>
</section>
